module.exports = __webpack_public_path__ + "static/media/hmax_3.fa549d63.jpg";